// 공통 UI 테마/스타일 상수// 임시 디자인 데이터
export const UI_THEME = {
  // 기본 배경/글자
  pageBg: "bg-white",
  textMain: "text-gray-900",
  textSub: "text-gray-500",

  // 버튼 색상 (차콜 계열)
  btnPrimary: "bg-gray-800 text-white hover:bg-gray-700 active:bg-gray-900",
  btnSecondary:
    "border border-gray-800 text-gray-800 hover:bg-gray-800 hover:text-white",
  btnDanger: "bg-red-500 text-white hover:bg-red-600 active:bg-red-700",

  // 공통 버튼 모양
  btnBase:
    "inline-flex items-center justify-center rounded-xl px-4 py-2 text-sm font-semibold transition-colors",

  // 카드/박스
  card: "bg-white border border-gray-200 rounded-2xl shadow-sm",
};
